// extracted by mini-css-extract-plugin
export var scrollArea = "_oi-0";